import { render, staticRenderFns } from "./confirmDuplicateModal.vue?vue&type=template&id=96bcc8c6"
import script from "./confirmDuplicateModal.vue?vue&type=script&lang=js"
export * from "./confirmDuplicateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports